<template>
    <div class="card">
        <div class="card-header pb-0">
            <div class="row align-top">
                <div class="col-md-2">
                    <h6>Productos</h6>
                </div>
                <div class="col-md-10">
                    <div class="input-group">
                        <span class="input-group-text text-body">
                        <i class="fas fa-search" aria-hidden="true"></i>
                        </span>
                        <input
                        type="text"
                        class="form-control"
                        v-model="searchTerm"
                        :placeholder="
                            this.$store.state.isRTL ? 'أكتب هنا...' : 'Buscar...'
                        "
                        />
                    </div>
                </div>
                <!-- <div class="col-md-2 ">
                    <argon-button
                    class="mt-0"
                    color="success"
                    fullWidth
                    size="xs"
                    @click="toCreate"
                    >Agregar Nuevo</argon-button> 
                </div> -->
            </div>
        </div>
        <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                    <thead>
                        <tr>
                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >Código</th>
                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >Producto</th>
                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >Moneda</th>
                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >Monto mínimo</th>
                            <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >Monto máximo</th>
                            <th
                            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                            >Tasa de interés</th>
                            <th
                            class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >Tasa de interés mínima</th>
                            <th
                            class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >Tasa de interés máxima </th>
                            <th
                            class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >Tasa de interés moratoria</th>
                            <th
                            class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >Tipo de interés</th>
                            <th
                            class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                            >Estado</th>
                            <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                                Acciones
                            </th>
                        
                        </tr>
                    </thead>
                    <tbody>
                        <tr 
                            v-for="(
                            {
                                id,
                                code,
                                name,
                                currency,
                                default_rate,
                                late_rate,
                                max_amount,
                                max_rate,
                                min_amount,
                                min_rate,
                                state,
                                interest_type

                            },
                            index
                            ) in filteredRows"
                            :key="index"
                        > 
                            <td>
                                <div class="d-flex px-2 py-1">
                                    <div class="d-flex flex-column justify-content-center">
                                    <h6 class="mb-0 text-sm">{{ code }}</h6>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="d-flex px-2 py-1">
                                    <div>
                                    
                                    </div>
                                    <div class="d-flex flex-column justify-content-center">
                                    <h6 class="mb-0 text-sm">{{name}}</h6>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0" v-if="currency=='1'">Cordobas</p>
                                <p class="text-xs font-weight-bold mb-0" v-if="currency=='2'">Dolares</p>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0 text-end">{{ min_amount }}</p>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0 text-end">{{ max_amount }}</p>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0 text-end">{{ default_rate }}</p>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0 text-end">{{ min_rate }}</p>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0 text-end">{{ max_rate }}</p>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0 text-end">{{ late_rate }}</p>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0 text-center" v-if="interest_type=='1'">Nominal</p>
                                <p class="text-xs font-weight-bold mb-0 text-center" v-if="interest_type=='2'">Integrado al capital (Flat)</p>
                            </td>
                            <td>
                                <p class="text-xs font-weight-bold mb-0" v-if="state=='1'">Activo</p>
                                <p class="text-xs font-weight-bold mb-0" v-if="state=='2'">Inactivo</p>
                            </td>
                            <td class="align-middle">
                            
                            <a
                                :href="'view-product/'+id"
                                class="btn bg-success mx-2"
                                data-toggle="tooltip"
                                data-original-title="Ver crédito"
                            ><i class="fa fa-folder text-white text-sm opacity-10"></i></a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
  
<script>
//import ArgonButton from "@/components/ArgonButton.vue";

export default {
    name: "patients-table",
    props: {
        clients:Array,
    },
    data(){
        return({
            searchTerm:null,
            clientsList: []
        })
    },
    components: { /*ArgonButton*/ },
    computed:{
        filteredRows(){
            if(!this.searchTerm){
                return this.clients;
            }else{
                return this.clients.filter(item => {
                    let firstName=item.name.toString().toLowerCase();
                    let documentNat=item.code.toString().toLowerCase();
                    return firstName.includes(this.searchTerm)||documentNat.includes(this.searchTerm)
                })
            }
        }
    },
    methods:{
        toCreate(){
            this.$router.push('/create-client')
        },
    },
};
</script>
  